import React from 'react';
import './AboutPage.css';

const VALUES = [
  { title: 'Mesleki dayanışma', desc: 'Kalite mühendisliği alanında ortak dil ve iş birliği.' },
  { title: 'Yetkinlik odaklılık', desc: 'Teknik bilgi ve uygulama becerilerinin geliştirilmesi.' },
  { title: 'Kurumsal kalite kültürü', desc: 'Sanayide sürdürülebilir kalite anlayışının yaygınlaştırılması.' },
  { title: 'Şeffaflık ve hesap verebilirlik', desc: 'Standartlara ve etik ilkelere bağlı çalışma.' },
];

const WHAT_WE_DO = [
  'Mesleki standartlar ve rehber dokümanların hazırlanması',
  'Sicil ve yetkinlik sisteminin geliştirilmesi ve yürütülmesi',
  'Eğitim, seminer ve bilgilendirme etkinlikleri',
  'Sanayi ile iş birlikleri ve uzman yönlendirme',
  'Ulusal ve uluslararası kurumlarla koordinasyon',
];

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container">
          <h1 className="about-hero-title">Hakkımızda</h1>
          <p className="about-hero-subtitle">
            Türkiye Kalite Mühendisleri Birliği – Kalite mühendisliği alanında ulusal temsil platformu
          </p>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">TKMB'yi Tanıyın</h2>
              <p className="about-intro">
                Türkiye Kalite Mühendisleri Birliği (TKMB), kalite mühendisliği alanında çalışan profesyoneller arasında
                mesleki koordinasyonu güçlendirmek ve kalite yönetimi uygulamalarının yaygınlaşmasına katkı sağlamak amacıyla
                oluşturulmuş ulusal düzeyde bir mesleki organizasyondur.
              </p>
              <p className="about-intro">
                Birlik, kalite kültürünü kurumsal düzeyde yaygınlaştırmak, mesleki standartların gelişimine katkıda bulunmak
                ve sanayide sürdürülebilir kalite anlayışının güçlenmesi için referans dokümanlar, sicil ve yetkinlik sistemi
                ile sanayi iş birlikleri üzerine çalışmalar yürütmektedir.
              </p>
            </div>
          </section>

          <section className="about-section">
            <div className="mission-vision-container">
              <div className="mission-vision-item">
                <h2 className="section-title">Vizyon</h2>
                <div className="section-content">
                  <p>
                    Kalite mühendisliği alanında ulusal ve uluslararası düzeyde referans kabul edilen bir yapı olmak.
                  </p>
                  <p className="section-note">
                    TKMB, meslek mensuplarının yetkinliklerinin tanınması, eğitim ve sertifikasyon süreçlerinin
                    uyumlaştırılması ve sektörde kalite kültürünün güçlendirilmesi hedeflerine hizmet eden bir referans
                    kurum olmayı hedeflemektedir.
                  </p>
                </div>
              </div>
              <div className="mission-vision-item">
                <h2 className="section-title">Misyon</h2>
                <div className="section-content">
                  <p>
                    Meslek mensuplarının teknik yetkinliklerini artırmak ve kalite odaklı yönetim anlayışını yaygınlaştırmak.
                  </p>
                  <p className="section-note">
                    Eğitim, rehber dokümanlar, sicil ve yetkinlik sistemi ile sanayi iş birlikleri aracılığıyla
                    kalite mühendisliği pratiğinin geliştirilmesine ve kurumsal kalite yönetiminin yaygınlaşmasına
                    katkı sağlamaktayız.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2 className="section-title section-title-center">Temel Değerlerimiz</h2>
            <div className="values-grid">
              {VALUES.map((item, index) => (
                <div key={index} className="value-card">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="about-section">
            <div className="section-container">
              <h2 className="section-title">Ne Yapıyoruz</h2>
              <p className="about-intro">
                TKMB, aşağıdaki alanlarda çalışmalar yürüterek kalite mühendisliği alanındaki mesleki koordinasyonu
                ve kalite kültürünü güçlendirmeyi amaçlamaktadır:
              </p>
              <ul className="about-do-list">
                {WHAT_WE_DO.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
